import * as _ from 'lodash'
export function popUp({ path, onClose, onMessage, windowName, windowOptions }) {
  windowName = windowName || 'ConnectWithOAuth' // should not include space for IE
  windowOptions = windowOptions || 'location=0,status=0,width=800,height=650'
  onClose = onClose || function () { }
  const _oauthWindow = window.open(path, windowName, windowOptions)
  const _oauthInterval = window.setInterval(function () {
    if (_oauthWindow && _oauthWindow.closed) {
      window.clearInterval(_oauthInterval)
      onClose()
    }
  }, 1000)
  const eventer = window.addEventListener

  eventer('message', function handler(e) {
    if (e.origin !== window.location.origin || e.source !== _oauthWindow) return
    window.removeEventListener('message', handler)
    !!onMessage && onMessage(e)
  })
  return _oauthWindow
}

export const GoogleScopes = Object.freeze({
  CALENDAR: 'https://www.googleapis.com/auth/calendar',
  READ: 'https://www.googleapis.com/auth/gmail.readonly',
  SEND: 'https://www.googleapis.com/auth/gmail.send',
})

export const encodeQueryData = function (data) {
  const ret = []
  for (const key in data) {
    const value = data[key]
    if (_.isArray(value)) {
      _.each(value, element =>
        ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(element)}`)
      )
    } else if (value != null) {
      ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  }
  return ret.join('&')
}



// WEBPACK FOOTER //
// ./src/layouts/utils/oauthUtils.js